/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as AccessDefs from "./defs.defs.js";

const $nsid = "place.stream.access.getStatus";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"subject":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"did":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"roles":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<AccessDefs.Role>((() => AccessDefs.role) as any), ),"policy":/*#__PURE__*/ l.ref<AccessDefs.PolicyView>((() => AccessDefs.policyView) as any),"space":/*#__PURE__*/ l.string(),"chatVerifiedOnly":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"chatVerified":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"networkMember":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Report the caller's roles on this node and the node's access policy. Works unauthenticated (roles then reflect what an anonymous visitor holds). This is the one place.stream method a node always answers, even to accounts locked out by a private viewer policy, so clients can render the right wall. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
